import api from "../services/api";
import { APIS } from "../endpoints";

/**
 * This function return songs data
 * @returns {Promise<Object>} - Function return Songs data
 */

export const getFilmsData = async (limit, page, searchTerm) => {
  const response = await getFilmsAPIData(limit, page, searchTerm);
  return response;
};

const _isDefaultFilterOptions = (opts) => {
  if (!opts || typeof opts !== "object") return true;
  const filters = opts.filters;
  const hasFilterValues =
    filters &&
    typeof filters === "object" &&
    Object.values(filters).some((v) =>
      Array.isArray(v) ? v.length > 0 : Boolean(v),
    );
  if (hasFilterValues) return false;
  if (opts.search) return false;
  return true;
};

export const getFilmsAPIData = async (
  limit,
  page,
  searchTerm,
  filterOptions = {},
) => {
  const formData = new FormData();
  formData.append("page", page);
  formData.append("limit", limit);

  if (!_isDefaultFilterOptions(filterOptions)) {
    const cleanedOptions = {
      ...filterOptions,
      filters: Object.fromEntries(
        Object.entries(filterOptions.filters || {}).filter(([, v]) =>
          Array.isArray(v) ? v.length > 0 : Boolean(v),
        ),
      ),
    };
    formData.append("filters", JSON.stringify(cleanedOptions));
  }

  if (searchTerm) {
    formData.append("search", searchTerm);
  }

  if (filterOptions.sortBy_v) {
    formData.append("sort_by", filterOptions.sortBy_v);
  }

  if (filterOptions.sortOrder_v) {
    formData.append("sort_order", filterOptions.sortOrder_v);
  }

  const params = new URLSearchParams(formData);
  const result = await api.get(`${APIS.BASE_URL}${APIS.films}`, { params });
  if (result) {
    return result?.data;
  } else {
    return [];
  }
};

export const getFilmPrimaryData = async (alias) => {
  const result = await api.get(
    `${APIS.BASE_URL}admin/film/${alias}/${APIS.filmBasic}`,
  );
  if (result) {
    return result?.data?.data;
  } else {
    return [];
  }
};

export const updateFilmPrimaryData = async (alias, data, deletedValues) => {
  const payload = {
    ...data,
    deletedValues: deletedValues,
  };

  const result = await api.put(
    `${APIS.BASE_URL}admin/film/${alias}/${APIS.filmBasic}`,
    payload,
  );

  if (result) {
    return result?.data;
  } else {
    return [];
  }
};

export const getFilmLandingPageData = async (alias) => {
  const result = await api.get(
    `${APIS.BASE_URL}admin/film/${alias}/${APIS.filmLandingPage}`,
  );
  if (result) {
    return result?.data?.data;
  } else {
    return [];
  }
};

export const updateFilmLandingPageData = async (alias, data) => {
  const result = await api.put(
    `${APIS.BASE_URL}admin/film/${alias}/${APIS.filmLandingPage}`,
    data,
  );

  if (result) {
    return result?.data;
  } else {
    return [];
  }
};

export const deleteFilmLandingPageData = async (alias, deletedItems) => {
  const result = await api.delete(
    `${APIS.BASE_URL}admin/film/${alias}/${APIS.filmLandingPage}`,
    { data: { deletedItems } },
  );

  if (result) {
    return result?.data;
  } else {
    return [];
  }
};

export const getFilmSpecificationData = async (alias) => {
  const result = await api.get(
    `${APIS.BASE_URL}admin/film/${alias}/${APIS.filmSpecifications}`,
  );
  if (result) {
    return result?.data?.data;
  } else {
    return [];
  }
};

export const updateFilmSpecificationData = async (
  alias,
  data,
  deletedValues,
) => {
  const payload = {
    ...data,
    deletedValues: deletedValues,
  };

  const result = await api.put(
    `${APIS.BASE_URL}admin/film/${alias}/${APIS.filmSpecifications}`,
    payload,
  );

  if (result) {
    return result?.data;
  } else {
    return [];
  }
};

export const getFilmPrefaceData = async (alias) => {
  const result = await api.get(
    `${APIS.BASE_URL}admin/film/${alias}/${APIS.filmPreface}`,
  );
  if (result) {
    return result?.data?.data;
  } else {
    return [];
  }
};

export const updateFilmPrefaceData = async (alias, data, deletedValues) => {
  const payload = {
    ...data,
    deletedValues: deletedValues,
  };

  const result = await api.put(
    `${APIS.BASE_URL}admin/film/${alias}/${APIS.filmPreface}`,
    payload,
  );

  if (result) {
    return result?.data;
  } else {
    return [];
  }
};

export const getFilmEditorialData = async (alias) => {
  const result = await api.get(
    `${APIS.BASE_URL}admin/film/${alias}/${APIS.filmEditorial}`,
  );
  if (result) {
    return result?.data?.data;
  } else {
    return [];
  }
};

export const updateFilmEditorialData = async (alias, data) => {
  const payload = {
    ...data,
  };
  const result = await api.put(
    `${APIS.BASE_URL}admin/film/${alias}/${APIS.filmEditorial}`,
    payload,
  );

  if (result) {
    return result?.data;
  } else {
    return [];
  }
};

export const getFilmSynopsisData = async (alias) => {
  const result = await api.get(
    `${APIS.BASE_URL}admin/film/${alias}/${APIS.filmSynopsis}`,
  );
  if (result) {
    return result?.data?.data;
  } else {
    return [];
  }
};

export const updateFilmSynopsisData = async (alias, data) => {
  const result = await api.put(
    `${APIS.BASE_URL}admin/film/${alias}/${APIS.filmSynopsis}`,
    data,
  );

  if (result) {
    return result?.data;
  } else {
    return [];
  }
};

export const getFilmCreditsCastsData = async (alias) => {
  const result = await api.get(
    `${APIS.BASE_URL}admin/film/${alias}/${APIS.filmCreditsCasts}`,
  );
  if (result) {
    return result?.data?.data;
  } else {
    return [];
  }
};

export const updateFilmCreditsCastsData = async (
  alias,
  data,
  deletedValues,
) => {
  const payload = {
    ...data,
    deletedValues: deletedValues,
  };

  const result = await api.put(
    `${APIS.BASE_URL}admin/film/${alias}/${APIS.filmCreditsCasts}`,
    payload,
  );

  if (result) {
    return result?.data;
  } else {
    return [];
  }
};

export const getWatchFilmData = async (alias) => {
  const result = await api.get(
    `${APIS.BASE_URL}admin/film/${alias}/${APIS.filmWatch}`,
  );
  if (result) {
    return result?.data?.data;
  } else {
    return [];
  }
};

export const updateWatchFilmData = async (alias, data) => {
  const result = await api.put(
    `${APIS.BASE_URL}admin/film/${alias}/${APIS.filmWatch}`,
    data,
  );

  if (result) {
    return result?.data;
  } else {
    return [];
  }
};

export const getFilmLyricsPageData = async (alias) => {
  const result = await api.get(
    `${APIS.BASE_URL}admin/film/${alias}/${APIS.filmLyrics}`,
  );
  if (result) {
    return result?.data?.data;
  } else {
    return [];
  }
};

export const updateFilmLyricsPageData = async (alias, data) => {
  const result = await api.put(
    `${APIS.BASE_URL}admin/film/${alias}/${APIS.filmLyrics}`,
    data,
  );

  if (result) {
    return result?.data;
  } else {
    return [];
  }
};

export const deleteFilmLyricsPageData = async (alias, deletedItems) => {
  const result = await api.delete(
    `${APIS.BASE_URL}admin/film/${alias}/${APIS.filmLyrics}`,
    { data: { deletedItems } },
  );

  if (result) {
    return result?.data;
  } else {
    return [];
  }
};

export const updateFilmImagesData = async (alias, data) => {
  console.log("data", data);
  const result = await api.put(
    `${APIS.BASE_URL}admin/film/${alias}/${APIS.filmEditorialImages}`,
    data,
  );

  if (result) {
    return result?.data;
  } else {
    return [];
  }
};

export const deleteFilmImagesData = async (alias, deletedItems) => {
  const result = await api.delete(
    `${APIS.BASE_URL}admin/film/${alias}/${APIS.filmEditorialImages}`,
    { data: { deletedItems } },
  );

  if (result) {
    return result?.data;
  } else {
    return [];
  }
};

export const getFilmScreeningsPageData = async (alias, masterlistType) => {
  const result = await api.get(
    `${APIS.BASE_URL}admin/${masterlistType}/${alias}/${APIS.screening}`,
  );
  if (result) {
    return result?.data?.data;
  } else {
    return [];
  }
};

export const updateFilmScreeningsPageData = async (
  alias,
  masterlistType,
  data,
) => {
  const result = await api.put(
    `${APIS.BASE_URL}admin/${masterlistType}/${alias}/${APIS.screening}`,
    data,
  );

  if (result) {
    return result?.data;
  } else {
    return [];
  }
};

export const deleteFilmScreeningsPageData = async (
  alias,
  masterlistType,
  deletedItems,
) => {
  const result = await api.delete(
    `${APIS.BASE_URL}admin/${masterlistType}/${alias}/${APIS.screening}`,
    { data: { deletedItems } },
  );

  if (result) {
    return result?.data;
  } else {
    return [];
  }
};

export const getFilmAwardsPageData = async (alias, masterlistType) => {
  const result = await api.get(
    `${APIS.BASE_URL}admin/${masterlistType}/${alias}/${APIS.awards}`,
  );
  if (result) {
    return result?.data?.data;
  } else {
    return [];
  }
};

export const updateFilmAwardsPageData = async (alias, masterlistType, data) => {
  const result = await api.put(
    `${APIS.BASE_URL}admin/${masterlistType}/${alias}/${APIS.awards}`,
    data,
  );

  if (result) {
    return result?.data;
  } else {
    return [];
  }
};

export const deleteFilmAwardsPageData = async (
  alias,
  masterlistType,
  deletedItems,
) => {
  const result = await api.delete(
    `${APIS.BASE_URL}admin/${masterlistType}/${alias}/${APIS.awards}`,
    { data: { deletedItems } },
  );

  if (result) {
    return result?.data;
  } else {
    return [];
  }
};
export const getSuggestionDataDataAPI = async (query) => {
  const BASE_URL = "https://staging.tuliresearchcentre.org/tris/api/";

  const result = await api.get(`${BASE_URL}${APIS.searchAutosuggest}=${query}`);
  if (result) {
    return result?.data;
  }
};

export const getResearchCategoriesAPI = async () => {
  const result = await api.get(`${APIS.BASE_URL}${APIS.allResearchCategory}`);
  if (result) {
    return result?.data?.data;
  }
};

export const getMasterlistTypesAPI = async (searchTerm) => {
  const result = await api.get(
    `${APIS.BASE_URL}${APIS.masterlistTypes}?search=${searchTerm}`,
  );
  if (result) {
    return result?.data;
  }
};
